import styles from "./footer-signature.module.css";

export default function FooterSignature() {
  return (
    <div className={styles["footer-signature-wrapper"]}>
      <p className={`${styles["footer-signature"]} poppins`}>
        creators.ae | ©2026
      </p>
      <p className={`${styles["footer-signature"]} poppins`}>
        Metasphere Technologies
      </p>
    </div>
  );
}
